module.exports = __webpack_public_path__ + "img/geofisica3_4-3_1536.cae7d624.webp";